import {
    Field as FinalField,
    FieldMetaState,
    Form as FinalForm
} from 'react-final-form'
import React, { useEffect } from 'react'
import { FieldComponent, FormComponent } from './types'
import { isEqual } from '../utils'
import { FORM_ERROR } from 'final-form'

// TODO generics
export const Form: FormComponent = ({
    onSubmit,
    validate,
    initialValues,
    initialValuesEqual,
    children: render,
    errors
}) => (
    <FinalForm
        initialValues={initialValues}
        onSubmit={async data => {
            try {
                await onSubmit(data)
            } catch (error) {
                return { [FORM_ERROR]: error }
            }
        }}
        validate={
            validate &&
            (d => {
                const res = validate(d)

                return res || undefined
            })
        }
        initialValuesEqual={initialValuesEqual}
        mutators={{
            errorSetter: ([field, value], s, tools) => {
                s.formState.errors = errors || {}
            }
        }}
    >
        {p => {
            useEffect(() => {
                // Update errors if changed
                const s = p.form.getState()
                if (isEqual(s.errors, errors)) return
                p.form.mutators.errorSetter()
            }, [errors])

            return render(p)
        }}
    </FinalForm>
)

const getErrors = (meta: FieldMetaState<any>): string[] => {
    const err = meta.error

    if (!err) return []
    if (Array.isArray(err)) return err

    // Must be a string
    return [err]
}

export const Field: FieldComponent = ({
    name,
    children: render,
    implProps
}) => (
    <FinalField name={name} allowNull={true} {...implProps}>
        {({ input, meta }) => {
            const errors = getErrors(meta)
            return render({
                input,
                onBlur: input.onBlur,
                onFocus: input.onFocus,
                errors: !meta.touched ? undefined : errors
            })
        }}
    </FinalField>
)
